import { AppBar, Dialog, DialogContent, IconButton, Toolbar, Tooltip, Typography } from '@material-ui/core';
import React from 'react';
import { Close } from '@material-ui/icons';
import { PDFDownloadLink } from '@react-pdf/renderer';
import BoreholeQrCodeDocument from '../pdf/QrCodeDocument';
import QrCodeService from '../../../services/qrCodeService';
import { Ecc } from '../../../@types/qrcodegen';
import StadiumButton from '../../customComponents/button/StadiumButton';
import { Transitions } from '../../customComponents/animations/Transitions';
import AppFunctionsService from '../../../services/appFunctionsService';
import BoreholeHelper, { IBorehole } from '../../../@types/model/borehole/borehole';

interface IBoreholeDownloadQrCodeButtonProps {
    value : IBorehole;

    onClose ?: () => void;
}

interface IBoreholeDownloadQrCodeButtonState {
    open : boolean;
}

export default class BoreholeDownloadQrCodeButton extends React.PureComponent<IBoreholeDownloadQrCodeButtonProps, IBoreholeDownloadQrCodeButtonState> {
    private readonly canvasRef : React.RefObject<HTMLCanvasElement>;
    constructor(props : IBoreholeDownloadQrCodeButtonProps) {
        super(props);
        this.state = {
            open: false,
        };

        this.canvasRef = React.createRef();
    }

    private readonly onRendered = () => {
        if (!this.canvasRef.current) return;

        QrCodeService.drawOnCanvas(this.canvasRef.current, {
            ecc: Ecc.HIGH,
            text: BoreholeHelper.getQrCodeText(this.props.value),
            scale: 4,
        });
    };

    private readonly onClick = () => {
        this.setState({
            open: true,
        });
    };

    private readonly onClose = () => {
        this.setState({
            open: false,
        });
    };
    
    public readonly render = () => {
        const {
            value,
        } = this.props;

        const {
            open,
        } = this.state;

        return (
            <React.Fragment>
                <Tooltip title='DownloadQrCode'>
                    <div>
                        <StadiumButton className='fw500 fs14 cp bcy' variant='contained' onClick={this.onClick}>
                            DOWNLOAD QR CODE
                        </StadiumButton>
                    </div>
                </Tooltip>
                <Dialog
                    open={open}
                    TransitionComponent={Transitions.ZoomIn}
                    transitionDuration={500}
                    maxWidth={'sm'}
                    fullWidth
                    aria-labelledby='archive-tree-dialog-title'
                    aria-describedby='archive-tree-description'
                    onRendered={this.onRendered}>
                    <AppBar className='fdr posr aic jcc bcpd' position='static'>
                        <Toolbar className={'fdr flx1 aic jcc'}>
                            <Typography>
                                DOWNLOAD QR CODE
                            </Typography>
                            <span className='flx1' />
                            <Tooltip title='Close'>
                                <div>
                                    <IconButton color='inherit' onClick={this.onClose} aria-label='Close'>
                                        <Close />
                                    </IconButton>
                                </div>
                            </Tooltip>
                        </Toolbar>
                    </AppBar>
                    <DialogContent>
                        <div className='fdc'>
                            <div className='fdc aic jcc'>
                                <canvas
                                    ref={this.canvasRef}
                                    width={808}
                                    height={800}
                                />
                            </div>
                            <div className='fdc aic jcc mt15'>
                                <Typography
                                    className='fs15 fwm cg3'
                                >
                                    {value.Code} - {AppFunctionsService.toTitleCase(value.Name)}
                                </Typography>
                            </div>
                            <div className='fdc aife jcc mt15'>
                                <PDFDownloadLink
                                    document={
                                        <BoreholeQrCodeDocument
                                            boreholes={[value]}
                                        />
                                    }
                                    fileName={`${value.Code}.pdf`}
                                    className={'tdn'}
                                >
                                    {
                                        ({
                                            loading,
                                        }) => (
                                            <Tooltip title='Download'>
                                                <div>
                                                    <StadiumButton
                                                        disabled={loading}
                                                        variant='contained'
                                                        className='fw500 fs14 cw bcp'
                                                        onClick={this.onClick}
                                                    >
                                                        DOWNLOAD
                                                    </StadiumButton>
                                                </div>
                                            </Tooltip>
                                        )
                                    }
                                </PDFDownloadLink>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        );
    };
}
